import React from 'react';
import styled from '@emotion/styled';
import { H3, Text } from 'ds/components/typography';

interface ParameterItemProps {
  title: React.ReactNode;
  subtitle: React.ReactNode;
  image: React.ReactNode;
}

const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  gap: ${({ theme }) => theme.spacing(2)};
`;

const ImageWrapper = styled.div`
  width: 150px;
  height: 150px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.5)};
  text-align: center;
`;

const SubTitle = styled(Text)`
  color: ${({ theme }) => theme.colors.neutrals.grey2};
  max-width: 242px;

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    max-width: 176px;
  `}
`;

export const ParameterItem: React.FC<ParameterItemProps> = ({ title, subtitle, image }) => {
  return (
    <Item>
      <ImageWrapper>
        {image}
      </ImageWrapper>
      <Content>
        <H3 weight="bold">
          {title}
        </H3>
        <SubTitle>
          {subtitle}
        </SubTitle>
      </Content>
    </Item>
  );
};
